import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch, store } from "../../../../redux/store";
import { fetchInsurers, deleteInsurer } from "./actions";
import MainTable from "../../../../components/mainTable";
import { ModalType } from "../../../../shared/utils/enums";
import { InsuranceCompany } from "../../../../interfaces/screens/billing";
import { showModal } from "../../../../connected-components/modal/reducer";
import InsurerEditor from "../../../../components/InsurerEditor";
import { getInsurersTableColumns } from "../../../../shared/tableColumns/insurersColumns";

const InsurersDashboard = () => {
  const dispatch: AppDispatch = useDispatch();
  const {
    data: insurers,
    loading,
    error,
  } = useSelector((state: RootState) => state.insurers);

  useEffect(() => {
    dispatch(fetchInsurers());
  }, [dispatch]);

  const handleEditInsurer = (insurer: InsuranceCompany) => {
    dispatch(
      showModal({
        title: "Edit Insurer",
        type: ModalType.COMPONENT,
        component: <InsurerEditor insurer={insurer} isEdit={true} />,
      }),
    );
  };

  const handleAddNewInsurer = () => {
    dispatch(
      showModal({
        title: "Add New Insurer",
        type: ModalType.COMPONENT,
        component: <InsurerEditor isEdit={false} />,
      }),
    );
  };

  const handleDeleteInsurer = (insurer: InsuranceCompany) => {
    dispatch(
      showModal({
        title: "Confirm Deletion",
        message: `Are you sure you want to delete ${insurer.name}? This action cannot be undone.`,
        type: ModalType.QUESTION,
        onConfirm: () => {
          dispatch(deleteInsurer(insurer.id));
        },
      }),
    );
  };

  const columns = getInsurersTableColumns({
    onEdit: handleEditInsurer,
    onDelete: handleDeleteInsurer,
  });

  return (
    <div className="pt-4">
      <MainTable
        data={insurers}
        columns={columns}
        isLoading={loading}
        onAddNewItemPress={handleAddNewInsurer}
        addButtonLabel="Add Insurer"
        showAddButton={true}
      />
      {error && <p className="text-red-500 mt-2">Error: {error}</p>}
    </div>
  );
};

export default InsurersDashboard; 